import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {environment} from '../../../../environments/environment';

/**
 * Access to the global window variable.
 */
declare let window: {
  [key: string]: any;
  prototype: Window;
  new (): Window;
};

@Injectable({
  providedIn: 'root'
})
export class AnalyticsInjectorService {
  constructor(@Inject(PLATFORM_ID) private readonly platformId) {
    if (isPlatformBrowser(this.platformId)) {
      window._paq = window._paq || [];
    } else {
      console.warn("MatomoInjector can't be used on server platform");
    }
  }

  init(docTitle: string) {
    const currentUrl = location.href;
    const url = environment.trackerUrl;
    if (url !== '') {
      // window.addEventListener('hashchange', function () {
      const siteId = environment.trackerSiteId;
      window._paq.push(['setReferrerUrl', currentUrl]);
      window._paq.push(['setCustomUrl', currentUrl]);
      window._paq.push(['setDocumentTitle', docTitle]);

      // make Matomo aware of newly added content
      const content = document.getElementById('content');
      window._paq.push(['trackContentImpressionsWithinNode', content]);
      window._paq.push(['trackPageView']);
      window._paq.push(['enableLinkTracking']);
      window._paq.push(['setTrackerUrl', `${url}matomo.php`]);
      window._paq.push(['setSiteId', siteId]);
      const d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0];
      g.type = 'text/javascript';
      g.async = true;
      g.defer = true;
      g.src = `${url}matomo.js`;
      s.parentNode.insertBefore(g, s);
      // });
    }
  }
}
